import React from "react"
import ReactMarkdown from "react-markdown"
import { featureAnnouncementShape } from "utils/propTypeShapes"

const FeatureAnnouncement = ({ featureAnnouncement }) => (
  <div className="feature-announcement-panel">
    <p className="font-bold">{featureAnnouncement.title}</p>

    <ReactMarkdown
      components={{
        a: ({ node, children, ...props }) => (
          <a {...props} target="_blank" rel="noopener noreferrer">
            {children}
          </a>
        ),
      }}
    >
      {featureAnnouncement.message}
    </ReactMarkdown>
  </div>
)

FeatureAnnouncement.propTypes = {
  featureAnnouncement: featureAnnouncementShape.isRequired,
}

export default FeatureAnnouncement
